import { TextField, FormControl, Grid, Typography, Box } from '@mui/material';
import { useRef, useState } from 'react';
import Styles from '../Styles/SearchMapsStyles';
import { debounceDelay } from '../../../settings/appConfig';
import { genericTitle } from '../../../assets/styles/appStyles';

interface CommonSearchProps {
  title: string;
  entityType: string;
  onSearchChanged: (searchText?: string, entityType?: string) => void;
}

export default function CommonSearch({
  title,
  entityType,
  onSearchChanged,
}: Readonly<CommonSearchProps>) {
  const [searchText, setSearchText] = useState<string>('');
  const timeoutId = useRef<number | null>(null);

  const handleChangeSearchText = (value: string) => {
    setSearchText(value);

    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    timeoutId.current = window.setTimeout(() => {
      onSearchChanged(value, entityType);
    }, debounceDelay);
  };

  return (
    <Grid container mt={2} sx={Styles.greyCard}>
      <Grid px={2} container justifyContent="space-between" alignItems="center">
        <Typography align="left" sx={genericTitle}>
          {title}
        </Typography>
      </Grid>

      <Grid
        px={2}
        mb={2}
        container
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item xs={12} md={6} lg={5}>
          <Box>
            <FormControl fullWidth>
              <TextField
                id={`search-${entityType}`}
                value={searchText}
                label="Search Text"
                variant="outlined"
                onChange={(e) =>
                  handleChangeSearchText(e.target.value)
                }
              />
            </FormControl>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}
